import axios from "axios";
import { API_BASE_URL } from "./config";
import { tokenStorage } from "../auth/tokenStorage";

const client = axios.create({
    baseURL: API_BASE_URL,
    timeout: 20000,
    headers: { "Content-Type": "application/json" },
});

// Attach bearer token on every request.
client.interceptors.request.use((config) => {
    const token = tokenStorage.getAccess();
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// 401 → drop the token and bounce to /login.
client.interceptors.response.use(
    (resp) => resp,
    (error) => {
        const status = error?.response?.status;
        if (status === 401 && typeof window !== "undefined") {
            tokenStorage.clear();
            if (window.location.pathname !== "/login") {
                const next = encodeURIComponent(window.location.pathname);
                window.location.href = `/login?next=${next}`;
            }
        }
        return Promise.reject(error);
    }
);

export default client;
